import { ReactNode, useState } from "react";
import { IconType } from "react-icons";

interface StatusItemProps {
  Icon: IconType;
  text: string;
  field: (onComplete: Function) => ReactNode;
  value: string | number | undefined;
}

const StatusItem: React.FC<StatusItemProps> = ({
  Icon,
  text,
  field,
  value,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  return (
    <div className="flex my-4 items-center">
      {!isEditing && (
        <>
          <Icon className="mr-2" /> <span>{text}</span>:{" "}
          <span className="ml-2 font-bold">{value}</span>{" "}
          <button
            type="button"
            className="block text-primary-dark cursor-pointer ml-2 underline font-medium"
            onClick={() => setIsEditing(true)}
          >
            Edit
          </button>
        </>
      )}

      {isEditing && field(() => setIsEditing(false))}
    </div>
  );
};

export default StatusItem;
